export default [
  {
    path: '/physical-handling/arrival-scan',
    name: 'arrival-scan',
    component: () => import('@/views/physical-handling/ArrivalScan.vue'),
    meta: {
      pageTitle: 'Arrival Scan',
      permissions: ['do arrival scans'],
    },
  },
]
